"use strict";function post$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.post$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="runtime.message.post";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.6.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.6.0"},_a)),exports.post$=post$,exports.default=post$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/runtime/message/post.js
// module id = 1087
// module chunks = 106